import "./NoMatchingResults.css";
import inboxIcon from "@ms/inbox.svg?raw";
import { Icon } from "@ui/Icon";
import { HStack, VStack } from "@ui/Stack";
import { Text } from "@ui/typography/Text";
import { type JSX, Match, Switch } from "solid-js";

export const NoMatchingResults = (props: {
	style?: JSX.CSSProperties;
	message: string;
	hint?: JSX.Element;
	icon?: string;
}) => {
	return (
		<VStack
			class="no-matching-results"
			align="center"
			justify="center"
			style={props.style}
			spacing="medium"
		>
			<HStack spacing="small" fullWidth align="center" justify="center">
				<Icon icon={props.icon ?? inboxIcon} />
				<Text
					transform="uppercase"
					weight="bold"
					as="h3"
					ellipsis
					family="mono"
				>
					{props.message}
				</Text>
			</HStack>
			<Switch>
				<Match when={props.hint}>
					<Text color="fg3" class="hint" size="small">
						{props.hint}
					</Text>
				</Match>
			</Switch>
		</VStack>
	);
};
